import React, { useEffect } from "react";
import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { I18nProvider, useI18n } from "@/i18n/I18nProvider";
import { ScrollToTop } from "@/components/layout/ScrollToTop";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { HomePage } from "@/pages/HomePage";
import { LegalPage } from "@/pages/LegalPage";
import { ThankYouPage } from "@/pages/ThankYouPage";
import { NotFoundPage } from "@/pages/NotFoundPage";

const DocumentTitle = () => {
  const { dict, lang } = useI18n();
  const location = useLocation();
  useEffect(() => {
    document.documentElement.lang = lang;
    let title = dict.meta.title;
    const path = location.pathname;
    if (path.endsWith("/privacy-policy")) title = `${dict.privacy.title} — Vexorqa`;
    else if (path.endsWith("/cookie-policy")) title = `${dict.cookie_policy.title} — Vexorqa`;
    else if (path.endsWith("/terms")) title = `${dict.terms.title} — Vexorqa`;
    document.title = title;
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", dict.meta.description);
  }, [dict, lang, location.pathname]);
  return null;
};

const LocalizedRoutes = () => (
  <SiteLayout>
    <DocumentTitle />
    <Routes>
      <Route index element={<HomePage />} />
      <Route path="privacy-policy" element={<LegalPage i18nKey="privacy" />} />
      <Route path="cookie-policy" element={<LegalPage i18nKey="cookie_policy" />} />
      <Route path="terms" element={<LegalPage i18nKey="terms" />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  </SiteLayout>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <I18nProvider>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Navigate to="/fr" replace />} />
            <Route path="/thank_you" element={<ThankYouPage />} />
            <Route path="/fr/*" element={<LocalizedRoutes />} />
            <Route path="/en/*" element={<LocalizedRoutes />} />
            <Route path="*" element={<Navigate to="/fr" replace />} />
          </Routes>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
